import { serviceName } from '../resources/serviceConstants';
import {
  BASE_EFFORTS,
  BASE_EFFORTS_SAVE,
  BASE_EFFORTS_EDIT,
} from '../resources/endPoint';

export const baseEffortList = () => {
  return {
    url: BASE_EFFORTS,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const savebaseEffort = (data) => {
  return {
    url: BASE_EFFORTS_SAVE,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const editbaseEffort = (data) => {
  return {
    url: BASE_EFFORTS_EDIT,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const deletebaseEffort = (id) => {
  return {
    url: `/v1/base-effort?id=${id}`,
    method: 'delete',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};
